import { Pipe, PipeTransform } from '@angular/core';
import { MaintenanceType } from './planned-maintenance-library-item';
import { I18NextPipe } from 'angular-i18next';

@Pipe({
  name: 'maintenanceType',
})
export class MaintenanceTypePipe implements PipeTransform {
  constructor(private i18NextPipe: I18NextPipe) {
  }
  transform(value: MaintenanceType, args?: any): string {
    switch (value) {
      case MaintenanceType.OnCondition: {
        return this.i18NextPipe.transform('MaintenanceTypePipe.OnCondition');
      }
      case MaintenanceType.ScheduledDiscardRestoration: {
        return this.i18NextPipe.transform('MaintenanceTypePipe.ScheduledDiscardRestoration');
      }
      case MaintenanceType.FailureFinding: {
        return this.i18NextPipe.transform('MaintenanceTypePipe.FailureFinding');
      }
    }
  }
}
